export default import.meta.ROLLDOWN_FILE_URL_eCqI$lvWQ4xjFpnVHyoJIA